import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'Gallery',
  dir: 'Gallery',
  pathRoot: 'gallery',
  routes: [
    {
      url: '',
      component: 'Page/index',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Ảnh lưu niệm | Smart Event',
        titleI18n: 'Gallery:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
    {
      url: ':id',
      component: 'Page/GalleryUpload',
      meta: {
        authRoute: true,
      },
      layout: 'FullLayout',
      props: {
        title: 'Ảnh lưu niệm | Smart Event',
        titleI18n: 'Gallery:title',
        headerStyle: 'fill',
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
};
